import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import client from "../../services/client";
import { ENDPOINTS } from "../../config";

// Thunk to fetch KYC list with filters
export const fetchAllKycList = createAsyncThunk(
  "kyc/fetchAll",
  async (filters, thunkAPI) => {
    
    try {
      const response = await client.post(
        `${ENDPOINTS.getAllKycList}`, // Adjust endpoint as needed
        filters
      );
      return response; // Ensure to return data to match the shape of your state
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unknown error occurred";
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

const initialState = {
  kycList: [],
  totalRows: 0,
  status: "idle",
  error: null,
};

const kycSlice = createSlice({
  
  name: "kyc",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    
    builder
      .addCase(fetchAllKycList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllKycList.fulfilled, (state, action) => {
        
        state.status = "succeeded";
        state.kycList = action.payload.data.data || [];
        state.totalRows = action.payload.data.totalElements || 0;
        state.error = null; // Clear error on success
      })
      .addCase(fetchAllKycList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default kycSlice.reducer;
